import React, { Component } from 'react';
import { images } from '../../../../settings';
import { BrowserRouter as Router, Link } from 'react-router-dom';

import './Liquidez.scoped.scss';

class Liquidez extends Component {
  constructor(props) {
    super(props);
    this.images = images;
  }
  render() {
    return (
      <div className="planos-template">
        <div className="planos-template--risca" style={{ backgroundColor: this.props.cor }}></div>
        <div className="planos-template__conteudo">
          {/* <h3 className="h2 h2--500 planos-template__titulo" style={{ color: this.props.cor }}>
            Liquidez
          </h3> */}
          <h4 className="planos-template__subtitulo">
            As iniciativas relacionadas à liquidez se deram em quatro frentes:
          </h4>
          <div className="planos-template__linha">
            <div className="planos-template__coluna">
              <div className="planos-template__imagem-coluna">
                <img src={this.images.plano_acao_2020.icon_liquidez1} alt="Ícone" />
              </div>
              <div className="planos-template__conteudo-coluna">
                <h5 className="planos-template__titulo-coluna">Gestão de liquidez</h5>
                <p>
                  Ao longo do ano, discutiram-se novos mecanismos de regulação para gestão de liquidez dos fundos. Foi
                  definido que propostas sobre o tema seriam endereçadas na resposta da Associação à audiência pública
                  divulgada pela CVM sobre fundos de investimento.
                </p>
                <p>
                  Em paralelo, foram revisadas as regras de autorregulação para gestão de liquidez dos fundos, definindo
                  os conceitos gerais das metodologias para avaliação do passivo e do ativo. Foi realizada conversa com
                  a CVM para apresentação inicial dos conceitos da proposta e iniciada interlocução com a B3, para
                  solicitar a divulgação de informações do mercado secundário que auxiliarão os gestores.
                </p>
              </div>
            </div>
          </div>

          <div className="planos-template__linha">
            <div className="planos-template__coluna">
              <div className="planos-template__imagem-coluna">
                <img src={this.images.plano_acao_2020.icon_liquidez2} alt="Ícone" />
              </div>
              <div className="planos-template__conteudo-coluna">
                <h5 className="planos-template__titulo-coluna">Crédito privado</h5>
                <p>
                  Foram avaliadas possíveis ações para desenvolver os fundos de crédito privado, como o fomento aos
                  fundos listados e a eventual criação de novos índices de crédito privado, mas decidiu-se pausar a
                  agenda. Concluiu-se que é necessário avançar nas iniciativas relacionadas ao aprimoramento das regras
                  de gestão de liquidez e à modernização da precificação para depois retomar esse tema específico.
                </p>
              </div>
            </div>
          </div>

          <div className="planos-template__linha">
            <div className="planos-template__coluna">
              <div className="planos-template__imagem-coluna">
                <img src={this.images.plano_acao_2020.icon_liquidez3} alt="Ícone" />
              </div>
              <div className="planos-template__conteudo-coluna">

                <a style={{"text-decoration":"none"}} href="https://data.anbima.com.br/" target="_blank">
                  <h5 className="planos-template__titulo-coluna">Precificação</h5>
                </a>
                <p>

                  As calculadoras de CRI (Certificado de Recebível Imobiliário) e CRA (Certificado de Recebível do
                  Agronegócio) foram disponibilizadas em dezembro no ANBIMA Data, o serviço digital de acesso gratuito à
                  nossa base de dados.
                </p>
                <p>
                  Também modernizamos o Price Challenger, o canal para envio de questionamentos referentes às taxas e
                  aos preços divulgados pela ANBIMA, que passou a ser digital.
                </p>
                <p>
                  Ao longo do ano, foram feitas simulações de alterações na metodologia de precificação de debêntures e de
                  CRI e CRA. Os estudos prosseguem, enquanto a nova metodologia de precificação de FIDCs (Fundos de
                  Investimento em Direitos Creditórios) foi aprovada internamente e deve ser aplicada até o final de
                  2021.
                </p>
              </div>
            </div>
          </div>

          <div className="planos-template__linha">
            <div className="planos-template__coluna">
              <div className="planos-template__imagem-coluna">
                <img src={this.images.plano_acao_2020.icon_liquidez4} alt="Ícone" />
              </div>
              <div className="planos-template__conteudo-coluna">

                <a style={{"text-decoration":"none"}} href="https://www.anbima.com.br/pt_br/representar/grupos-de-trabalho/padronizacao-de-debentures/padronizacao-de-debentures.htm" target="_blank">
                  <h5 className="planos-template__titulo-coluna">Mercado secundário</h5>
                </a>

                
                <p>
                  O Guia de Padronização de Debêntures teve a sua divulgação reforçada junto a agentes de mercado,
                  especialmente escritórios de advocacia, além da Abrasca (Associação Brasileira das Companhias Abertas)
                  e da CVM. Também foi levado às demais entidades participantes da IMK (Iniciativa de Mercado de
                  Capitais, grupo do governo que busca fomentar o segmento). Internamente, houve divulgação para as
                  comissões de Gestão de Carteira e de Private.
                </p>
                <p>
                  O Guia para Formador de Mercado ganhou uma nova versão, com apresentações para as comissões
                  de Produtos de Tesouraria, Renda Fixa, Gestão de Carteira e Private. Como parte das ações para
                  disseminação deste material, assim como do Guia de Padronização de Debêntures, realizamos em outubro
                  uma live aberta a todo o mercado. Até o final de 2020, o vídeo contava com mais de 450 visualizações
                  no Youtube.
                </p>
                <p>
                  Ao longo do ano organizamos diversas conversas com prestadores de serviços no Brasil e no exterior,
                  para melhor entendimento das funcionalidades de suas plataformas de negociação eletrônica e sugestão
                  de aprimoramentos necessários para atender às demandas específicas do nosso mercado.
                </p>
                <p>
                  Também foram iniciadas as discussões sobre mecanismos para short selling de títulos privados, com base nos
                  pleitos anteriores, para definição de possíveis aprimoramentos às regras locais.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export { Liquidez };
